import { Component, Inject, OnInit} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { Voucher } from 'app/models/vouchers/voucher';
import { VoucherApplication } from 'app/models/vouchers/voucher-application';
import { VoucherLetter } from 'app/models/vouchers/voucher-letter';
import { VoucherLetterEmailViewModel } from 'app/models/vouchers/voucher-letter-email-viewmodel';
import { HouseholdService } from 'app/services/household-service';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'send-letter',
  templateUrl: './send-letter.component.html',
  styleUrls: ['./send-letter.component.scss']
})
export class SendLetterComponent implements  OnInit {
  voucher: Voucher = undefined;
  household: IHousehold = undefined;
  voucherApplication: VoucherApplication = undefined;
  processing: boolean = false;
  processingMessage: string = "";
  letter: VoucherLetter = undefined;
  contactMethods: string[] = ["Mail", "Email"];
  applicantContactEmail: string = "";
  
  selectedTreatmentContractorEmail: string = "";
  treatmentContractorEmails: string[] = ["", "ceric_97838@yahoo.com","info@hellman.construction"];

  sendLetterForm = new FormGroup({
    contactDate: new FormControl("", Validators.required),
    contactType: new FormControl("", Validators.required),
    contactComment: new FormControl(""),
    treatmentContractorEmail: new FormControl("")
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: VoucherLetter,
              public voucherService: VoucherService, 
              private toastr: ToastrService, 
              private sharedService: SharedService,
              public householdService: HouseholdService,
              private dialogRef: MatDialogRef<SendLetterComponent>,
              public oregonWellDataService: OregonWellDataService) {                
                this.letter = data;
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
     let voucherId = 0;
     if(this.letter.voucherId != null) {
      voucherId = +this.letter.voucherId;
     }
    if(voucherId > 0) {
      this.loadVoucher();
    }
    
    else if(this.letter.applicationId != null  && this.letter.applicationId > 0) {
      this.loadVoucherApplicaiton();
    }
    else if(this.letter.householdId != null  && this.letter.householdId > 0) {
      this.loadHousehold();
    }
    else {
      this.toastr.error("Unknown letter type.");
      this.dialogRef.close();
    }
  }

  loadHousehold() {
    this.processing = true;
    this.processingMessage = "Loading";
    
    this.sendLetterForm.get('contactDate').setValue(this.letter.contactDate);
    this.sendLetterForm.get('contactType').setValue(this.letter.contactType);
    this.sendLetterForm.get('contactComment').setValue(this.letter.contactComment);
    this.householdService.getHouseholdById(+this.letter.householdId).subscribe(
      result => {
        this.household = result;
        this.applicantContactEmail = this.household.contactEmail;
        this.processing = false;
        this.processingMessage = "";
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );

  }

  loadVoucher() {
    this.processing = true;
    this.processingMessage = "Loading";
    
    this.sendLetterForm.get('contactDate').setValue(this.letter.contactDate);
    this.sendLetterForm.get('contactType').setValue(this.letter.contactType);
    this.sendLetterForm.get('contactComment').setValue(this.letter.contactComment);
    this.voucherService.getVoucherById(+this.letter.voucherId).subscribe(
      result => {
        this.voucher = result;
        this.applicantContactEmail = this.voucher.applicantContactEmail;
        this.processing = false;
        this.processingMessage = "";
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  loadVoucherApplicaiton() {
    
    this.processing = true;
    this.processingMessage = "Loading";
    
    this.sendLetterForm.get('contactDate').setValue(this.letter.contactDate);
    this.sendLetterForm.get('contactType').setValue(this.letter.contactType);
    this.sendLetterForm.get('contactComment').setValue(this.letter.contactComment);
    this.voucherService.getVoucherApplicationById(+this.letter.applicationId).subscribe(
      result => {
        this.voucherApplication = result;
        this.applicantContactEmail = this.voucherApplication.applicantContactEmail;
        this.processing = false;
        this.processingMessage = "";
      },
      error => {
        this.processing = false;
        this.processingMessage = "";
      }
    );
  }

  emailLetter() {
    let email = "";
    if(this.voucher != undefined && this.voucher != null) {
      email = this.voucher.applicantContactEmail;
    }
    else if(this.voucherApplication != undefined && this.voucherApplication != null) {
      email = this.voucherApplication.applicantContactEmail;
    }
    else if(this.household != undefined && this.household != null) {
      email = this.household.contactEmail;
    }
    else {
      this.toastr.error("Letter Type Not Supported.");
      return;
    }
    this.sharedService.openConfirm("Are you sure you want to email this letter to: " + email + "?");
    this.sharedService.confirmed().subscribe( confirmed => {
      if(confirmed) { 
        this.processingMessage = "Sending Letter...";
        this.processing = true;
    
        var emailViewModel: VoucherLetterEmailViewModel = {
          letterId: this.letter.id,
          email:email
        }

        if(this.voucher != undefined && this.voucher != null) {
          this.voucherService.emailLetter(emailViewModel).subscribe(
            result => {
              this.processingMessage = "";
              this.processing = false;
              this.toastr.success("Letter Sent!");
              this.dialogRef.close();
            },
            error => {
              this.processing = false;
              this.processingMessage = "";
            }
          );
        }
        else if(this.voucherApplication != undefined && this.voucherApplication != null) {
          this.voucherService.emailApplicationLetter(emailViewModel).subscribe(
            result => {
              this.processingMessage = "";
              this.processing = false;
              this.toastr.success("Letter Sent!");
              this.dialogRef.close();
            },
            error => {
              this.processing = false;
              this.processingMessage = "";
            }
          );
        }
        else if(this.household != undefined && this.household != null) {
          
          this.householdService.emailLetter(emailViewModel).subscribe(
            result => {
              this.processingMessage = "";
              this.processing = false;
              this.toastr.success("Letter Sent!");
              this.dialogRef.close();
            },
            error => {
              this.processing = false;
              this.processingMessage = "";
            }
          );
        }

      }
    });
  }

  emailTreatmentContractorLetter() {
    if(this.sendLetterForm.value.treatmentContractorEmail == null 
        || this.selectedTreatmentContractorEmail.length == 0 || this.selectedTreatmentContractorEmail == '') {

      this.toastr.error("Please select a Treatment Contractor Email from the dropdown");
      return;
    }

    this.sharedService.openConfirm("Are you sure you want to email this letter to Treatment Contractor: " + this.selectedTreatmentContractorEmail + "?");

    this.sharedService.confirmed().subscribe( confirmed => {
      if(confirmed) { 
        this.processingMessage = "Sending Letter...";
        this.processing = true;

        var emailViewModel: VoucherLetterEmailViewModel = {
          letterId: this.letter.id,
          email:this.selectedTreatmentContractorEmail
        }
      
        this.voucherService.emailLetter(emailViewModel).subscribe(
          result => {
            this.processingMessage = "";
            this.processing = false;
            this.toastr.success("Letter Sent!");
            this.dialogRef.close();
          },
          error => {
            this.processing = false;
            this.processingMessage = "";
          }
        );
      }
    });
  }

  setTreatmentContractor(){
    this.selectedTreatmentContractorEmail = this.sendLetterForm.value.treatmentContractorEmail;
  }

  updateLetter() {
    if(!this.sendLetterForm.valid) {
      this.toastr.error("Please enter all required fields");
      return;
    }

    this.letter.contactDate = this.sendLetterForm.value.contactDate;
    this.letter.contactType = this.sendLetterForm.get('contactType').value;
    this.letter.contactComment = this.sendLetterForm.get('contactComment').value;

    if(this.letter.contactType == undefined || this.letter.contactType == null || this.letter.contactType.length == 0) {
      this.toastr.error("Please enter all required fields");
      return;
    }

    this.processingMessage = "Updating Letter...";
    this.processing=true;

    if(this.voucher != undefined || this.voucherApplication != undefined) {
      this.voucherService.updateLetterInfo(this.letter).subscribe(
        result => {
          this.processingMessage = "";
          this.processing = false;
          this.toastr.success("Letter Information updated!");
          this.dialogRef.close();
        },
        error => {
          this.processing = false;
          this.processingMessage = "";
        }
      );
    }
    else if(this.household != undefined) {
      this.householdService.updateLetterInfo(this.letter).subscribe(
        result => {
          this.processingMessage = "";
          this.processing = false;
          this.toastr.success("Letter Information updated!");
          this.dialogRef.close();
        },
        error => {
          this.processing = false;
          this.processingMessage = "";
        }
      );
    }
   
  }
}